module.exports = __webpack_public_path__ + "img/9.8a26eda9.png";